import React from 'react';
import { NavLink } from 'react-router-dom';
import { 
    FaHome, FaBriefcase, FaEnvelope, FaPlus, FaSignInAlt, 
    FaClipboardList, FaSearch, FaUserCircle, FaBars 
} from 'react-icons/fa';
import { useAuth } from '../context/AuthContext';

const MobileNavbar = () => {
    const { isAuthenticated, user } = useAuth();

    // --- Guest Navigation ---
    const guestItems = [
        { path: '/', icon: <FaHome />, label: 'Home' },
        { path: '/jobs', icon: <FaSearch />, label: 'Browse' },
        { path: '/login', icon: <FaSignInAlt />, label: 'Login' },
        { path: '/register', icon: <FaUserCircle />, label: 'Join' },
    ];

    // --- Buyer Navigation ---
    const buyerItems = [
        { path: '/', icon: <FaHome />, label: 'Home' },
        { path: '/my-jobs', icon: <FaClipboardList />, label: 'My Jobs' },
        { path: '/publish-job', icon: <FaPlus />, isCenter: true },
        { path: '/messages', icon: <FaEnvelope />, label: 'Chat' },
        { path: '/menu', icon: <FaBars />, label: 'Menu' }, // Changed Wallet to Menu
    ];

    // --- Worker Navigation ---
    const workerItems = [
        { path: '/', icon: <FaHome />, label: 'Home' },
        { path: '/worker-dashboard/running-jobs', icon: <FaBriefcase />, label: 'Work' },
        { path: '/jobs', icon: <FaSearch />, isCenter: true },
        { path: '/messages', icon: <FaEnvelope />, label: 'Chat' },
        { path: '/menu', icon: <FaBars />, label: 'Menu' }, // Changed Wallet to Menu
    ];

    // Select items based on role
    const navItems = !isAuthenticated 
        ? guestItems 
        : user?.role === 'buyer' 
            ? buyerItems 
            : workerItems;

    return (
        <div className="md:hidden fixed bottom-0 left-0 right-0 bg-white/95 backdrop-blur-xl border-t border-slate-200 z-[100] px-2 pb-safe shadow-[0_-10px_30px_rgba(0,0,0,0.05)]">
            <div className="flex justify-around items-center h-16 relative">
                {navItems.map((item, idx) => (
                    item.isCenter ? (
                        <NavLink
                            key={idx}
                            to={item.path}
                            className="flex flex-col items-center justify-center -mt-12"
                        >
                            <div className="w-14 h-14 bg-emerald-600 rounded-2xl shadow-xl shadow-emerald-200 flex items-center justify-center text-white border-4 border-white transition-transform active:scale-90 rotate-45">
                                <div className="-rotate-45 flex items-center justify-center">
                                    {item.icon}
                                </div>
                            </div>
                        </NavLink>
                    ) : (
                        <NavLink
                            key={idx}
                            to={item.path}
                            className={({ isActive }) => 
                                `flex flex-col items-center justify-center gap-1 transition-all flex-1 min-w-[60px] ${
                                    isActive ? 'text-emerald-600 scale-105' : 'text-slate-400'
                                }`
                            }
                        >
                            <span className="text-xl">{item.icon}</span>
                            <span className="text-[9px] font-black uppercase tracking-tighter">{item.label}</span>
                        </NavLink>
                    )
                ))}
            </div>
        </div>
    );
};

export default MobileNavbar;
